import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractAutocompleteInput} from "../abstract-autocomplete-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterAutocompleteInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-autocomplete-input",
    styleUrls: ["./filter-autocomplete-input.component.scss"],
    templateUrl: "./filter-autocomplete-input.component.html",
    standalone: false
})
export class FUIFilterAutocompleteInputComponent extends FUIAbstractAutocompleteInput {
    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(changeDetectorRef, elementRef, eventsService, optionsService);
    }
}
